const ABOUT_IMG =
    "https://customer-assets.emergentagent.com/job_audio-engineer-denis/artifacts/kkr1g3fn_ChatGPT%20Image%2030%20gen%202026%2C%2022_42_11.png";

export const About = () => {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="px-6 lg:px-12 py-24 lg:py-32 border-t border-black/15 bg-paper"
        >
            <div className="max-w-[1440px] mx-auto grid grid-cols-12 gap-y-12 lg:gap-x-12 items-stretch">
                <div className="col-span-12 lg:col-span-7" data-testid="about-image-wrap">
                    <div className="aspect-[4/5] lg:aspect-[5/6] w-full overflow-hidden border border-black/15 grain bg-ink">
                        <img
                            src={ABOUT_IMG}
                            alt="Denis Catapano at the laptop, working in the studio"
                            className="w-full h-full object-cover"
                            style={{ filter: "grayscale(1) brightness(1.15) contrast(1)" }}
                            data-testid="about-image"
                        />
                    </div>
                </div>

                <div className="col-span-12 lg:col-span-5 lg:pl-6 flex flex-col justify-center">
                    <p className="overline" data-testid="about-overline">
                        (03) — About
                    </p>
                    <h2
                        data-testid="about-title"
                        className="mt-6 font-serif-display text-5xl sm:text-6xl lg:text-7xl tracking-[-0.02em] leading-[0.95] text-ink"
                    >
                        About me.
                    </h2>

                    <div
                        className="mt-10 font-sans text-lg leading-[1.55] text-ink/90 space-y-6 max-w-xl"
                        data-testid="about-body"
                    >
                        <p>
                            My name is Denis, and I have been working as a mix
                            and mastering engineer for years, collaborating
                            with independent artists on projects intended for
                            release.
                        </p>
                        <p className="text-quiet">
                            My work focuses on the final stage of a song:
                            turning a production into a finished, solid, and
                            cohesive record — ready for release on all
                            platforms.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
